import { Menu, MenuProps } from 'antd';
import CaretIcon from '../assets/caret.svg';
import { Link } from 'react-router-dom';
import { Paths } from '../routes';
import { useAtom } from 'jotai';
import { userAtom, globalAtom } from '../store/atom';
import { useEffect } from 'react';

type MenuItem = Required<MenuProps>['items'][number];

const Navigation = () => {
  const [globalState] = useAtom(globalAtom);
  const [userState, setUserState] = useAtom(userAtom);
  const userRole = globalState.userRole;

  useEffect(() => {
    const path = window.location.pathname;
    if (Paths.MyProfile === path || path === '/') {
      setUserState({ ...userState, activeNav: 'My Profile' });
    } else if (Paths.MyFeedbackNotes === path) {
      setUserState({ ...userState, activeNav: 'My Feedback Notes' });
    }
  }, []);

  const items: MenuItem[] = [
    {
      label: (
        <div className="flex gap-x-2">
          Mentee Management <img src={CaretIcon} alt="caret-icon" />
        </div>
      ),
      key: '1',
      children: [
        {
          key: 'Assigned Mentees',
          label: <Link to={Paths.AllMentees}>Assigned Mentees</Link>,
        },
        {
          key: 'All Annual Reviews',
          label: (
            <Link to={Paths.MentorAllAnnualReviews}>All Annual Reviews</Link>
          ),
        },
        {
          key: 'All Quarterly Reviews',
          label: <Link to={Paths.AssignedMentees}>All Quarterly Reviews</Link>,
        },
        {
          key: 'Feedback Notes',
          label: <Link to={Paths.FeedbackNotes}>Feedback Notes</Link>,
        },
      ],
    },
    {
      label: (
        <div className="flex gap-x-2">
          Profile Management <img src={CaretIcon} alt="caret-icon" />
        </div>
      ),
      key: '2',
      children: [
        {
          key: 'My Profile',
          label: <Link to={Paths.MyProfile}>My Profile</Link>,
        },
        {
          key: 'My Feedback Notes',
          label: <Link to={Paths.MyFeedbackNotes}>My Feedback Notes</Link>,
        },
      ],
    },
    {
      label: (
        <div className="flex gap-x-2">
          HR Operations <img src={CaretIcon} alt="caret-icon" />
        </div>
      ),
      key: '3',
      disabled: false,
      children: [
        {
          key: 'Employee Dashboard',
          label: <Link to={Paths.EmployeeDashboard}>Employee Dashboard</Link>,
        },
        {
          key: 'HR Dashboard',
          label: <Link to={Paths.FeedbackDashboard}>HR Dashboard</Link>,
        },
        {
          key: 'All Annual Review Cycles(HR)',
          label: (
            <Link to={Paths.HRAllAnnualReviews}>All Annual Review Cycles</Link>
          ),
        },
        {
          key: 'All Quarter Review Cycles(HR)',
          label: (
            <Link to={Paths.HRAllReviews}>All Quarterly Review Cycles</Link>
          ),
        },
      ],
    },
  ].filter((i) => {
    if (
      userRole.isHR === false &&
      userRole.isMentor === false &&
      (i.key === '1' || i.key === '3')
    )
      return false;
    if (userRole.isHR === false && i.key === '3') return false;
    if (userRole.isMentor === false && i.key === '1') return false;
    return true;
  });

  const onClick: MenuProps['onClick'] = (e) => {
    setUserState({ ...userState, activeNav: e.key });
  };

  return (
    <div className="px-[10px] w-full flex mb-[10px] bg-white">
      <div className="ml-auto">
        <Menu
          onClick={onClick}
          selectedKeys={[userState.activeNav]}
          mode="horizontal"
          items={items}
          className="border-0 ml-auto"
          disabledOverflow
        />
      </div>
    </div>
  );
};

export default Navigation;
